import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'clsx'
import SVG from 'react-inlinesvg'
import { navigate } from 'gatsby'
import _find from 'lodash/find'
// Components
import {
  TimelineArrowUpIcon,
  TimelineArrowDownIcon,
} from '~2023/components/Icons'
// Styles
import { useStyles } from './Timeline.style.js'

const filterSelector = (state) => state.filter

const Timeline = ({
  categoryNext = null,
  categoryPrevious = null,
  overallNext = null,
  overallPrevious = null,
  fromModal,
  closeTo,
  isMobile,
  isDetail,
}) => {
  const classes = useStyles()

  const {
    data: { id: filterId, isFiltered: isFiltered },
  } = useSelector(filterSelector)

  const isButtonUpVisible = overallPrevious
  const isButtonDownVisible = overallNext

  // const handleHashLink = value => navigate(value)
  const handleUp = () => {
    if (isButtonUpVisible) {
      !isFiltered &&
        navigate(overallPrevious.frontmatter.path, {
          state: {
            closeToLink: closeTo,
            fromModal,
            ...(fromModal && { modal: true }),
          },
        })

      isFiltered &&
        navigate(
          _find(categoryPrevious, (c) => c.categoryId == filterId).frontmatter
            .path,
          {
            state: {
              closeToLink: closeTo,
              fromModal,
              ...(fromModal && { modal: true }),
            },
          }
        )
      return true
    }
  }
  const handleDown = () => {
    if (isButtonDownVisible) {
      !isFiltered &&
        navigate(overallNext.frontmatter.path, {
          state: {
            closeToLink: closeTo,
            fromModal,
            ...(fromModal && { modal: true }),
          },
        })
      isFiltered &&
        navigate(
          _find(categoryNext, (c) => c.categoryId == filterId).frontmatter.path,
          {
            state: {
              closeToLink: closeTo,
              fromModal,
              ...(fromModal && { modal: true }),
            },
          }
        )

      return true
    }
  }

  return (
    <div className="timelineInfo">
      <section
        className={cx(
          classes.timeline,
          classes.timelineFandom,
          isMobile && classes.isMobile,
          isDetail && classes.isDetailTimeline
        )}
      >
        <button
          className={classes.arrow}
          disabled={!isButtonUpVisible}
          onClick={handleDown}
        >
          <SVG
            description="An arrow pointing up"
            height={11}
            src={TimelineArrowUpIcon}
            title="Scroll Timeline Up"
            width={9}
          />
        </button>
        <button
          className={classes.arrow}
          disabled={!isButtonDownVisible}
          onClick={handleUp}
        >
          <SVG
            description="An arrow pointing down"
            height={11}
            src={TimelineArrowDownIcon}
            title="Scroll Timeline Down"
            width={9}
          />
        </button>
      </section>
    </div>
  )
}

export default Timeline
